import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00fcd4ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fixedbar"
};
const _hoisted_2 = {
  class: "applist"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "item",
  href: "tel:400-6868-860"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "icon phone"
}), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 咨询电话 "), /*#__PURE__*/_createElementVNode("p", null, "400-6868-860")])], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon custom"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "在线客服", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "item",
  href: "https://mp.weixin.qq.com/s/5gawnatU3MU4NnE3c6ry6Q?vid=1688856558460079&deviceid=e2c53aa3-5908-4ca1-ab61-3904d0d8888d&version=4.1.2.6017&platform=win"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "icon wchart"
}), /*#__PURE__*/_createElementVNode("div", null, "微信公众号")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "app"
}, [/*#__PURE__*/_createElementVNode("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.8478 4.25551L17.8228 4.97801C18.6966 5.2976 19.2874 6.1851 19.1466 7.15926L19.1171 7.35456C18.1094 13.7782 13.5992 18.1035 7.21572 19.1418L7.12231 19.1547C6.19096 19.2615 5.34694 18.6965 5.02114 17.8634L4.26739 15.9343L4.23972 15.8573C4.01126 15.1622 4.33444 14.3947 5.00864 14.0809L8.02072 12.6788L8.10623 12.6423C8.56638 12.463 9.08793 12.5297 9.48989 12.823L10.532 13.5847L10.6148 13.5307C11.1227 13.1903 11.6011 12.8121 12.042 12.3983L12.2286 12.2188L12.4186 12.0268C12.8558 11.5732 13.2492 11.0816 13.5908 10.5545L13.6673 10.4323L13.652 10.4568L12.8849 9.35343L12.8332 9.27378C12.589 8.86887 12.5551 8.36812 12.7466 7.93218L14.0191 5.03718L14.0539 4.9635C14.3835 4.31287 15.1511 4.00078 15.8478 4.25551ZM15.4643 5.88998L14.3189 8.49665L15.1035 9.62457L15.1508 9.69713C15.4215 10.1402 15.447 10.7164 15.1585 11.1912L15.0069 11.4337C14.5432 12.1541 14.0007 12.8122 13.3985 13.4058L13.1824 13.6137C12.5995 14.1606 11.9645 14.6495 11.2922 15.0787L11.2145 15.125C10.7169 15.4004 10.1161 15.3455 9.67431 15.0225L8.60848 14.2437L5.89015 15.5087L6.57348 17.2566C6.63836 17.4228 6.78052 17.5018 6.90672 17.4999L6.94806 17.4962L7.13325 17.465C12.7931 16.4764 16.6683 12.6395 17.4968 6.9204L17.4999 6.8768C17.4996 6.74457 17.414 6.6029 17.2501 6.5429L15.4643 5.88998ZM9.58319 0.833635C9.81277 0.823219 9.99986 1.01072 9.99986 1.24114V2.07614C9.99986 2.30614 9.81319 2.49155 9.58319 2.50405C5.76861 2.7128 2.71277 5.76864 2.50402 9.58322C2.49152 9.81322 2.30611 9.99989 2.07611 9.99989H1.24111C1.01069 9.99989 0.823188 9.8128 0.833605 9.58322C1.04527 4.84697 4.84694 1.0453 9.58319 0.833635ZM10 4.57754V5.41254C10 5.64296 9.81294 5.82712 9.58378 5.84962C7.61294 6.04504 6.04503 7.61296 5.84961 9.58379C5.82711 9.81296 5.64294 10 5.41253 10H4.57753C4.34753 10 4.15961 9.81296 4.17586 9.58337C4.37961 6.69087 6.69086 4.37962 9.58336 4.17587C9.81294 4.15962 10 4.34754 10 4.57754ZM10.0001 7.91428V9.58345C10.0001 9.81345 9.81343 10.0001 9.58344 10.0001H7.91427C7.68427 10.0001 7.49385 9.8122 7.53177 9.58511C7.70718 8.53553 8.53552 7.7072 9.5851 7.53178C9.81218 7.49386 10.0001 7.68428 10.0001 7.91428Z",
  fill: "currentColor"
})])], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
export default {
  __name: 'mobile',
  setup(__props) {
    const showTalk = () => {
      TUNGEE_IM.run('show');
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_back_top = _resolveComponent("a-back-top");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tooltip, {
        placement: "topRight",
        color: "white",
        getPopupContainer: terget => terget.parentNode,
        trigger: "click"
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
          class: "item",
          onClick: _cache[0] || (_cache[0] = $event => showTalk())
        }, _hoisted_6), _hoisted_7])]),
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      }, 8, ["getPopupContainer"]), _createVNode(_component_a_back_top, {
        class: "gotop"
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      })]);
    };
  }
};